import * as images from './images'

// Logo
export const logo = [{ id: 1, image: images.thirteenthghost }]
// Navigation and social links
export const pageLinks = [
	{ id: 1, href: '/#home', text: 'home' },
	{ id: 2, href: '/#about', text: 'about the music' },
	{ id: 3, href: '/#top', text: 'Top 10 Albums' },
	{ id: 5, href: '/#metalcollection', text: 'The Metal collection' },
	{ id: 6, href: '/#rockcollection', text: 'The Rock collection' },
	{ id: 7, href: '/#aderitopereira', text: 'The Aderito P. collection' },
]
export const socialLinks = [
	{ id: 1, href: 'https://www.facebook.com', icon: 'fab fa-facebook' },
	{ id: 2, href: 'https://x.com/', icon: 'fa-brands fa-twitter' },
	{ id: 3, href: 'https://www.instagram.com', icon: 'fab fa-instagram' },
]
// Top albums
export const top = [
	{
		id: 1,
		title: 'Album#1',
		text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores, officia.',
		image: images.ironmaiden1,
	},
	{
		id: 2,
		title: 'Album#2',
		text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores, officia.',
		image: images.ironmaiden1,
	},
	{
		id: 3,
		title: 'Album#3',
		text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores, officia.',
		image: images.ironmaiden1,
	},
	{
		id: 4,
		title: 'Album#4',
		text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores, officia.',
		image: images.ironmaiden1,
	},
	{
		id: 5,
		title: 'Album#5',
		text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores, officia.',
		image: images.ironmaiden1,
	},
	{
		id: 6,
		title: 'Album#6',
		text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores, officia.',
		image: images.ironmaiden1,
	},
	{
		id: 7,
		title: 'Album#6',
		text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores, officia.',
		image: images.ironmaiden1,
	},
	{
		id: 8,
		title: 'Album#8',
		text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores, officia.',
		image: images.ironmaiden1,
	},
	{
		id: 9,
		title: 'Album#9',
		text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores, officia.',
		image: images.ironmaiden1,
	},
	{
		id: 10,
		title: 'Album#10',
		text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores, officia.',
		image: images.ironmaiden1,
	},
]
// Top rock albums
export const toprocks = [
	{
		id: 1,
		title: 'Album#1',
		text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores, officia.',
		image: images.ironmaiden1,
	},
	{
		id: 2,
		title: 'Album#2',
		text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores, officia.',
		image: images.ironmaiden1,
	},
	{
		id: 3,
		title: 'Album#3',
		text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores, officia.',
		image: images.ironmaiden1,
	},
	{
		id: 4,
		title: 'Album#4',
		text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores, officia.',
		image: images.ironmaiden1,
	},
	{
		id: 5,
		title: 'Album#5',
		text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores, officia.',
		image: images.ironmaiden1,
	},
	{
		id: 6,
		title: 'Album#6',
		text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores, officia.',
		image: images.ironmaiden1,
	},
	{
		id: 7,
		title: 'Album#6',
		text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores, officia.',
		image: images.ironmaiden1,
	},
	{
		id: 8,
		title: 'Album#8',
		text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores, officia.',
		image: images.ironmaiden1,
	},
	{
		id: 9,
		title: 'Album#9',
		text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores, officia.',
		image: images.ironmaiden1,
	},
	{
		id: 10,
		title: 'Album#10',
		text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores, officia.',
		image: images.ironmaiden1,
	},
]
